<template>
  <v-autocomplete
    @input="event => { emitChange(event) }"
    :items="items"
    v-model="selectedItem"
    :label="inputLabel"
    item-text="text"
    item-value="value"
    :clearable="true"
    outlined
    dense
  >
  </v-autocomplete>
</template>

<script>
import Api from "@/services/Api";

export default {
  data () {
    return {
      selectedItem: '',
      items: [],
      inputLabel: this.$t('message.select_flowchart')
    }
  },
  props: {
    value: null,
    label: null,
    list: null,
    showIcon: null
  },
  created() {
    if(this.label)
      this.inputLabel = this.label;
    if(this.list && this.list.length > 0){
      this.items = this.list;
    }else{
      Api().get("flowcharts/admins/managedacademy/" +
        this.$store.state.managedAcademy)
        .then(res => {
          if (res && res.data.flowcharts) {
            this.items = res.data.flowcharts.map((doc) => {
              return {
                value: doc._id,
                text: doc.name,
              };
            });
          }
        })
        .catch(err => {
          if (err)
            this.showAlert('error', this.$t('message.oops_not_working'));
        });
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedItem = newValue
      }
    }
  },
  methods: {
    emitChange (event) {
      this.$emit('input', event)
    },
  }
}
</script>

<style scoped>
</style>